export function clearLocalStorageKeys(keys: string[]): void {
  keys.forEach((key) => {
    localStorage.removeItem(key);
  });
}
